import { LayoutContainer } from '../../containers/advancedFilters/LayoutContainer';
import { IFilter } from '../../types/filters';

export const layout: IFilter = {
  component: LayoutContainer,
};
